<template>
  <div v-loading="isLoading" class="padded">
    <utility-detail v-if="bill" :row-data="bill" />
    <template v-else-if="!isLoading">
      <el-alert
        v-if="fetchError"
        type="error"
        :closable="false"
        show-icon
        title="Couldn't load bill">
        <span>
          Failed to load the bill
          <template v-if="fetchError !== 'network'"> (HTTP {{ fetchError }})</template>
          <template v-else> — network error</template>.
        </span>
        <el-button size="small" style="margin-top: 8px;" @click="fetch">Retry</el-button>
      </el-alert>
      <div v-else class="text-muted">Bill not found.</div>
    </template>
  </div>
</template>

<script>
/*
 * L2 layer content for the `d.bill.<id>` drawer entry registered in
 * `src/lib/drawerRegistry.js`. Fetches the single bill and renders
 * UtilityDetail.
 *
 * Site context: under the d.bill.<id> grammar, the URL does not encode a
 * site id. The L1 drawer beneath (typically d.siteUtil.<id>) already shows
 * the site context to the user via the cascade peek, so the UtilityDetail
 * "site" panel is intentionally left empty here. If a future grammar pushes
 * the site id into the bill segment (e.g. d.bill.<id>.<tab>.<siteId>), wire
 * the site fetch via a registry-supplied arg.
 */
import axios from '@/lib/axiosClient'

import UtilityDetail from '@/components/utility/UtilityDetail'

export default {
  components: {
    UtilityDetail
  },

  props: {
    billId: {
      type: Number,
      required: true
    },
    // tab/subtab reserved for future drawer-stack deep-linking; unused today.
    tab: {
      type: String,
      default: null
    },
    subtab: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      bill: null,
      isLoading: true,
      fetchError: null
    }
  },

  watch: {
    billId: 'fetch'
  },

  mounted () {
    this.fetch()
  },

  methods: {
    fetch () {
      this.isLoading = true
      this.fetchError = null
      axios.get(this.getEndpoint('utility/' + this.billId))
        .then(billRes => {
          this.bill = billRes.data
        })
        .catch(err => {
          this.bill = null
          this.fetchError = (err.response ? err.response.status : 'network')
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
